import { render, staticRenderFns } from "./MonitorColumn.vue?vue&type=template&id=55006706&"
import script from "./MonitorColumn.vue?vue&type=script&lang=js&"
export * from "./MonitorColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports